import * as types from './actionTypes'
import Immutable from 'seamless-immutable'

const initialState = Immutable({
    route: '',
    loading: false,
    errorText: '',
    keyword: '',
    events: [],
})

export default function reduce(state = initialState, action = {}) {

    switch (action.type) {
        
        case types.ROUTE_SET:
            return state.merge({
                route: action.value,
            })

        case types.LOADING_SET:
            return state.merge({
                loading: action.value,
            })

        case types.ERROR_SET:
            return state.merge({
                errorText: action.value,
            })

        case types.KEYWORD_SET:
            return state.merge({
                keyword: action.value,
            })

        case types.EVENTS_SET:
            return state.merge({
                events: action.value,
            })

        case types.PURCHASE_SET:
            return state.merge({
                purchase: action.value,
            })

        default:
            return state
    }
}

export function getRoute(state) {
    return state.adminEvent.route
}

export function getLoading(state) {
    return state.adminEvent.loading
}

export function getKeyword(state) {
    return state.adminEvent.keyword
}

export function getError(state) {
    return state.adminEvent.errorText
}

export function getEvents(state) {
    return state.adminEvent.events
}

export function getPurchase(state) {
    return state.adminEvent.purchase
}
